import Vue from 'vue'
import vuetifyNsuk from '../plugins/vuetify'
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import axios from 'axios';
import "vue-toastification/dist/index.css";
import NotificationPlugin from '../plugins/notify';
import urlUtil from "@/utils/urlUtil";
import Api from "@/main/api";
import RoleMagicLinkAuth from './nsuk/components/RoleMagicLinkAuth.vue';

axios.defaults.baseURL = urlUtil.getBaseUrl();

Vue.config.productionTip = false;
Vue.use(NotificationPlugin)
Vue.use(VueToast);

new Vue({
  vuetify: vuetifyNsuk,
  render: h => h(RoleMagicLinkAuth, {
    props: {
      accessTitle: 'Supervisor Access',
      verifyMagicLink: Api.auth.verifySupervisorMagicLink,
    },
  })
}).$mount('#app')
